import { getLogger } from '@nerdwallet/logging';

export default getLogger(process.env.CLIENT_ID || 'app');
